import { useEffect, useState } from 'react';

/**
 * useDebouncedValue — returns the input value after it has been stable for
 * the specified delay. Used by `useServerAutosave` to throttle form-change
 * events into one debounced PUT.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
